import React from "react";

const SummarySection = ({
  summaryRows, totalRow
}) => {
  const TotalRow = () => (
    <tr className="font-weight-bold bg-secondary text-white">
      <td>Total:</td>
      <td>{totalRow.jobsComplete}</td>
      <td>{totalRow.totalWorkedTime}</td>
    </tr>
  )

  return (
    <React.Fragment>
      <div className="mb-4">
        <h5 className="mb-3">Summary Report</h5>
        <div className="table-responsive">
          <table className="table table-listing table-hover table-striped">
            <thead>
              <tr>
                <th>Draftman</th>
                <th>Jobs Complete</th>
                <th>Time Spent</th>
              </tr>
            </thead>
            <tbody>
              { summaryRows.map(row => (
                <tr key={row.name}>
                  <td>{row.name}</td>
                  <td>{row.jobsComplete}</td>
                  <td>{row.totalWorkedTime}</td>
                </tr>
              ))}
              {TotalRow()}
            </tbody>
          </table>
        </div>
      </div>
    </React.Fragment>
  )
}

export default SummarySection
